<template>
  <div class="home__view">
    <IntroComponent />
    <Competencies />
    <Communities />
    <!-- <Recognition /> -->
    <Press />
    <Footer />
  </div>
</template>

<script>
import IntroComponent from "@/components/IntroComponent.vue";
import Competencies from "@/components/Competencies.vue";
import Communities from "@/components/Communities.vue";
// import Recognition from "@/components/Recognition.vue";
import Press from "@/components/Press.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Home",
  components: {
    IntroComponent,
    Competencies,
    Communities,
    // Recognition,
    Press,
    Footer
  }
};
</script>
